import axiosInstance from '@/plugins/api/axiosInstance';
import generateQueryParams from '@/utils/generateQueryParams';

export default function whatsappContentTemplates() {
    return {
        index,
        get
    };

    function index(options = {}) {
        const defaultValues = {
            pattern: '',
            limit: 25,
            page: 1
        };
        const params = generateQueryParams(options, defaultValues);
        return axiosInstance.get(`twilio-template/search${params}`);
    }

    function get(id) {
        return axiosInstance.get(`twilio-template/get?id=${id}`);
    }
}
